import buttonShapes from "@insite/mobius/Button/buttonShapes";
import { pxToRem } from "@store/Framework/Common/Utilities/unitHelper";

Object.assign(buttonShapes, {
    rounded: () => `border-radius: ${pxToRem(4)};`,
});
